export interface SubscriptionFeatureEligibility {
    readonly isEnabled: boolean;
    readonly isReady: boolean;
}

interface SubscriptionFeatureEligibilityOptions {
    readonly featureEnabled: boolean;
    readonly isSubscriptionUser: boolean;
    readonly isSubscriptionUserReady: boolean;
}

export function getSubscriptionFeatureEligibility({
    featureEnabled,
    isSubscriptionUser,
    isSubscriptionUserReady,
}: SubscriptionFeatureEligibilityOptions): SubscriptionFeatureEligibility {
    const isReady = !featureEnabled || isSubscriptionUserReady;

    return {
        isEnabled: isReady && featureEnabled && isSubscriptionUser,
        isReady,
    };
}
